export default __webpack_public_path__ + "static/media/myTeamBanner.580805ec.jpg";